<template>
  <v-container>
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="$t('coursetemplates.enrolment_preview')"></page-header-title>
        <v-spacer></v-spacer>
        <action-button type="back" @click="$router.go(-1)" />
      </v-app-bar>

      <v-container grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex lg8 md8 sm12 xs12>
            <v-flex xs12>
              <v-card>
                <v-card-text class="pa-4 enr-course-description">
                  <span style="white-space: break-spaces">{{ coursetemplate.short_description }}</span>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text class="pa-4 mt-2 mb-2 enr-course-description">
                  <div v-if="coursetemplate.long_description && coursetemplate.long_description.length > 500">
                    <span style="white-space: break-spaces" v-if="!readMoreActivated"
                      >{{ coursetemplate.long_description.slice(0, 500) + "... " }}
                    </span>
                    <a class="" v-if="!readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                      >{{ $t("global.show_more") }}...</a
                    >

                    <span style="white-space: break-spaces" v-if="readMoreActivated">{{ coursetemplate.long_description }} </span>
                    <a class="" v-if="readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                      >{{ $t("global.show_less") }}...</a
                    >
                  </div>
                  <div v-if="coursetemplate.long_description && coursetemplate.long_description.length <= 500">
                    <span style="white-space: break-spaces">{{ coursetemplate.long_description }} </span>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-tabs background-color="primary" class="enr-tabs" dark v-model="active_tab" grow :disabled="true">
              <v-tab class="subheading font-weight-light">{{ $t("fe.enrolment.organisation_title") }}</v-tab>
              <v-tab class="subheading font-weight-light">{{ $t("fe.enrolment.personal_title") }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="active_tab">
              <v-tab-item :key="0">
                <v-card>
                  <v-card-text class="pa-4">
                    <v-container grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-subheader class="pl-0">{{ $t("fe.enrolment.details") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex xs12>
                              <v-select
                                name="p_course_id"
                                class="required-field"
                                v-validate="'required'"
                                :label="$t('fe.enrolment.p_course_id')"
                                :disabled="true"
                                clearable
                              ></v-select>
                            </v-flex>
                            <v-flex lg5 md6 sm9 xs12>
                              <v-combobox
                                name="o_name"
                                :label="$t('fe.enrolment.o_name')"
                                autocomplete="new-password"
                                :disabled="true"
                              ></v-combobox>
                            </v-flex>
                            <v-flex lg3 md3 sm3 xs12>
                              <v-text-field
                                name="o_vat"
                                class="required-field"
                                :label="$t('fe.enrolment.o_vat')"
                                :disabled="true"
                                :hint="$t('global.helptext_vat')"
                                persistent-hint
                                :append-outer-icon="'sync'"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="o_first_name"
                                :label="$t('fe.enrolment.o_first_name')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="o_last_name"
                                :label="$t('fe.enrolment.o_last_name')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="o_email"
                                :label="$t('fe.enrolment.o_email')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="o_reference"
                                :label="$t('fe.enrolment.o_reference')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                name="enrolment.comments"
                                rows="2"
                                auto-grow
                                :label="$t('fe.enrolment.comment')"
                                :disabled="true"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>

                          <v-divider class="my-4"></v-divider>

                          <v-subheader class="pl-0">{{ $t("fe.enrolment.invoice_address") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_street"
                                :label="$t('fe.enrolment.p_address_street')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_city"
                                :label="$t('fe.enrolment.p_address_city')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_zip"
                                :label="$t('fe.enrolment.p_address_zip')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-autocomplete
                                name="p_address_country"
                                :label="$t('fe.enrolment.p_address_country')"
                                autocomplete="new-password"
                                :disabled="true"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>

                          <v-divider class="my-4"></v-divider>

                          <v-layout wrap>
                            <v-flex xs12 class="text-center">
                              <v-checkbox name="coursetype" dense v-validate="'required'" class="d-inline-flex" :disabled="true">
                              </v-checkbox>
                              <p class="d-inline-flex va-top privacy-line">
                                {{ $t("fe.enrolment.privacy_consent_to") }}
                                <a class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                              </p>

                              <br />

                              <v-btn class="mb-3" color="primary" large :disabled="true">{{ $t("fe.enrolment.submit") }}</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-card>
                  <v-card-text class="pa-4">
                    <v-container grid-list-md class="pa-0">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-subheader class="pl-0">{{ $t("fe.enrolment.details") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex xs12>
                              <v-select
                                name="p_course_id"
                                class="required-field"
                                :label="$t('fe.enrolment.p_course_id')"
                                :disabled="true"
                              ></v-select>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_first_name"
                                class="required-field"
                                :label="$t('fe.enrolment.p_first_name')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_last_name"
                                class="required-field"
                                :label="$t('fe.enrolment.p_last_name')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_email"
                                class="required-field"
                                :label="$t('fe.enrolment.p_email')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_mobile"
                                class="required-field"
                                :label="$t('fe.enrolment.p_mobile')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-dialog ref="dialog" persistent width="290px" :disabled="true">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    name="p_date_of_birth"
                                    :label="$t('fe.enrolment.p_date_of_birth')"
                                    class="required-field"
                                    append-icon="event"
                                    :hint="'Format: ' + DATE_FORMAT"
                                    :disabled="true"
                                    autocomplete="new-password"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  color="primary"
                                  first-day-of-week="1"
                                  :locale="this.$locale_bcp47(this.locale)"
                                  :disabled="true"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" class="darken-2" @click="dob_date_menu = false">{{ $t("global.ok") }}</v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                name="enrolment.comments"
                                rows="2"
                                auto-grow
                                :label="$t('fe.enrolment.comment')"
                                :disabled="true"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>

                          <v-divider class="my-4"></v-divider>

                          <v-subheader class="pl-0">{{ $t("fe.enrolment.invoice_address") }}</v-subheader>

                          <v-layout wrap>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_street"
                                :label="$t('fe.enrolment.p_address_street')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_city"
                                :label="$t('fe.enrolment.p_address_city')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-text-field
                                name="p_address_zip"
                                :label="$t('fe.enrolment.p_address_zip')"
                                :disabled="true"
                                autocomplete="new-password"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg4 md4 sm6 xs12>
                              <v-autocomplete
                                name="p_address_country"
                                :label="$t('fe.enrolment.p_address_country')"
                                :disabled="true"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>

                          <v-divider class="my-4"></v-divider>

                          <v-layout wrap>
                            <v-flex xs12 class="text-center">
                              <v-checkbox name="coursetype" dense v-validate="'required'" class="d-inline-flex" :disabled="true">
                              </v-checkbox>
                              <p class="d-inline-flex va-top privacy-line">
                                {{ $t("fe.enrolment.privacy_consent_to") }}
                                <a class="pl-1 privacy-link">{{ $t("fe.enrolment.privacy_notice") }}</a>
                              </p>

                              <br />

                              <v-btn class="mb-3" color="primary" large :disabled="true">{{ $t("fe.enrolment.submit") }}</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-card>
              <v-card-text class="pa-4">
                <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.include") }}</p>

                <div v-for="mt in moduletemplates_included" :key="mt.id">
                  <p class="font-weight-black">{{ mt.name }}</p>

                  <div v-if="mt.module_options.length > 0">
                    <v-radio-group
                      dense
                      v-model="selectedIncAdditionals[mt.id].selected_option"
                      @change="moduleoptionChangeInc"
                      class="radio-full-width"
                      v-validate="'required'"
                      :name="'mo.' + mt.id"
                    >
                      <v-simple-table dense>
                        <tr v-if="!mt.mandatory">
                          <td scope="row">
                            <v-radio dense :label="$t('global.none_select')" value="none"></v-radio>
                          </td>
                          <td scope="row" class="text-end" width="40%"></td>
                        </tr>
                        <tr v-for="mo in mt.module_options" :key="mo.id">
                          <td scope="row">
                            <v-radio dense :label="mo.name + (mo.price ? ' (' + mo.price + ')' : '')" :value="mo.id"></v-radio>
                            <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                          </td>
                          <td scope="row" class="text-end va-text-top" width="40%">
                            <span v-if="mo.hours > 0">{{ mo.hours }} {{ $t("moduleoptions.hours") }}</span>
                          </td>
                        </tr>
                      </v-simple-table>
                    </v-radio-group>

                    <div v-for="mo in mt.module_options" :key="mo.id">
                      <div v-if="moduleoptioncoursetypesinc[mo.id].length > 0 && selectedIncAdditionals[mt.id].selected_option == mo.id">
                        <v-divider class="my-2"></v-divider>

                        <p>
                          {{ mt.name }} -
                          <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                        </p>
                        <v-simple-table dense class="mt-3">
                          <tr v-for="moct in moduleoptioncoursetypesinc[mo.id]" :key="moct.id">
                            <td scope="row">
                              <v-checkbox
                                :name="'moct.' + mt.id"
                                dense
                                :label="moct.name + (moct.price ? ' (' + moct.price + ')' : '')"
                                v-model="selectedIncAdditionals[mt.id].selected_coursetypes"
                                :value="moct.id"
                                class="chk-moduleoption"
                                @change="moduleoptionChangeInc"
                                v-validate="'required'"
                              ></v-checkbox>
                              <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                            </td>
                            <td scope="row" class="text-end va-text-top" width="40%"></td>
                          </tr>
                        </v-simple-table>
                      </div>
                    </div>
                    <v-divider class="my-2"></v-divider>
                  </div>
                </div>

                <p class="font-weight-black sidebar-price-title">{{ $t("fe.enrolment.additionals") }}</p>

                <div v-for="mt in moduletemplates_not_included" :key="mt.id">
                  <p class="font-weight-black">{{ mt.name }}</p>

                  <v-radio-group
                    dense
                    v-model="selectedAdditionals[mt.id].selected_option"
                    class="radio-full-width"
                    @change="moduleoptionChange"
                    v-validate="'required'"
                    :name="'mo.' + mt.id"
                  >
                    <v-simple-table dense>
                      <tr v-if="!mt.mandatory">
                        <td scope="row">
                          <v-radio dense :label="$t('global.none_select')" value="none"></v-radio>
                        </td>
                        <td scope="row" class="text-end" width="40%"></td>
                      </tr>
                      <tr v-for="mo in mt.module_options" :key="mo.id">
                        <td scope="row">
                          <v-radio dense :label="mo.name + (mo.price ? ' (' + mo.price + ')' : '')" :value="mo.id"></v-radio>
                          <span class="pl-3 mb-3 d-block">{{ mo.comment }}</span>
                        </td>
                        <td scope="row" class="text-end va-text-top" width="40%">
                          <span v-if="mo.hours > 0">{{ mo.hours }} {{ $t("moduleoptions.hours") }}</span>
                        </td>
                      </tr>
                    </v-simple-table>
                  </v-radio-group>
                  <div v-for="mo in mt.module_options" :key="mo.id">
                    <div v-if="moduleoptioncoursetypes[mo.id].length > 0 && selectedAdditionals[mt.id].selected_option == mo.id">
                      <v-divider class="my-3"></v-divider>

                      <p>
                        {{ mt.name }} -
                        <span class="font-italic">{{ $t("fe.enrolment.select_course_types") }}</span>
                      </p>
                      <v-simple-table dense class="mt-3">
                        <tr v-for="moct in moduleoptioncoursetypes[mo.id]" :key="moct.id">
                          <td scope="row">
                            <v-checkbox
                              :name="'moct.' + mt.id"
                              dense
                              :label="moct.name + (moct.price ? ' (' + moct.price + ')' : '')"
                              v-model="selectedAdditionals[mt.id].selected_coursetypes"
                              :value="moct.id"
                              class="chk-moduleoption"
                              @change="moduleoptionChange"
                              v-validate="'required'"
                            ></v-checkbox>
                            <span class="pl-3 mb-3 d-block">{{ moct.comment }}</span>
                          </td>
                          <td scope="row" class="text-end va-text-top" width="40%"></td>
                        </tr>
                      </v-simple-table>
                    </div>
                  </div>
                  <v-divider class="my-3"></v-divider>
                </div>

                <v-divider class="my-3"></v-divider>

                <v-simple-table dense class="mt-3">
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black">{{ $t("fe.enrolment.price") }}</p>
                    </td>
                    <td scope="row" class="text-end" width="40%">{{ price }}</td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black">{{ $t("fe.enrolment.price_additional") }}</p>
                    </td>
                    <td scope="row" class="text-end" width="40%">{{ price_additional }}</td>
                  </tr>
                  <tr>
                    <td scope="row">
                      <p class="font-weight-black">{{ $t("fe.enrolment.price_total") }}</p>
                    </td>
                    <td scope="row" class="text-end" width="40%">{{ price_total }}</td>
                  </tr>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "preview",

  props: ["id", "locale"],

  data() {
    return {
      page_title: "",

      coursetemplate: {},
      course: {
        coursetype: {
          fullname: ""
        },
        price: 0
      },
      enrolment: {},
      enrolmentDone: false,

      readMoreActivated: false,

      courses: [],
      moduletemplates: [],
      moduletemplates_included: [],
      moduletemplates_not_included: [],

      moduleoptioncoursetypes: {},
      selectedAdditionals: {},

      moduleoptioncoursetypesinc: {},
      selectedIncAdditionals: {},

      price: 0,
      price_additional: 0,
      price_total: 0,

      available_enrolment: 0,

      active_tab: 0
    }
  },

  computed: {
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.enrolment.date_of_birth)
      },
      set(val) {
        this.$set(this.enrolment, "date_of_birth", this.$dateFormatSetter(val))
      }
    }
  },

  created() {
    let vm = this

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios.get(this.API_URL + "coursetemplate/" + this.id).then((res) => {
      this.coursetemplate = res.data.data
      this.loadTemplate()
    })
  },

  mounted() {
    this.$validator.localize(this.locale, this.dictionary)
  },

  methods: {
    loadTemplate() {
      let vm = this

      this.moduletemplates = this.coursetemplate.moduletemplates

      // Filter "Included" module templates
      this.moduletemplates_included = this.moduletemplates.filter((i) => i.is_included == 1 && !i.hide_in_enrolment)

      this.moduletemplates_included.forEach(function (mt) {
        vm.$set(vm.selectedIncAdditionals, mt.id, {})
        vm.$set(vm.selectedIncAdditionals[mt.id], "selected_coursetypes", [])

        if (mt.module_options.length == 1) {
          vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? mt.module_options[0].id : "none")
        } else {
          vm.$set(vm.selectedIncAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
        }

        // Show only module option where "Enrol Select" is checked
        mt.module_options = mt.module_options.filter((i) => i.enrol_select == 1)

        mt.module_options.forEach(function (mo) {
          vm.moduleoptioncoursetypesinc[mo.id] = []
          vm.moduleoptioncoursetypesinc[mo.id] = mo.module_options_course_types
        })
      })

      // Filter "Not Included" module templates
      this.moduletemplates_not_included = this.moduletemplates.filter((i) => i.is_included != 1 && !i.hide_in_enrolment)

      this.moduletemplates_not_included.forEach(function (mt) {
        vm.$set(vm.selectedAdditionals, mt.id, {})
        vm.$set(vm.selectedAdditionals[mt.id], "selected_coursetypes", [])

        if (mt.module_options.length == 1) {
          vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? mt.module_options[0].id : "none")
        } else {
          vm.$set(vm.selectedAdditionals[mt.id], "selected_option", mt.mandatory ? "" : "none")
        }

        // Show only module option where "Enrol Select" is checked
        mt.module_options = mt.module_options.filter((i) => i.enrol_select == 1)

        mt.module_options.forEach(function (mo) {
          vm.moduleoptioncoursetypes[mo.id] = []
          vm.moduleoptioncoursetypes[mo.id] = mo.module_options_course_types
        })
      })

      // Reinitialize validator dictionary
      this.recompute()
    },
    moduleoptionChange() {
      let vm = this

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypes[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },
    moduleoptionChangeInc() {
      let vm = this

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let selected_option = obj.selected_option
        let selected_coursetypes = obj.selected_coursetypes

        if (selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          let moct_ids = vm.moduleoptioncoursetypesinc[selected_option].map((a) => a.id)
          obj.selected_coursetypes = _.intersection(moct_ids, selected_coursetypes)
        } else {
          obj.selected_coursetypes = []
        }
      })

      vm.recompute()
    },
    recompute() {
      let vm = this

      vm.price = Boolean(_.has(vm.coursetemplate, "id")) ? vm.coursetemplate.price : 0
      vm.price_additional = 0
      vm.price_total = 0

      _.forEach(vm.selectedIncAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypesinc[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.module_options.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypesinc[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
            }
          })
        }
      })

      _.forEach(vm.selectedAdditionals, function (obj, key) {
        let mt = vm.moduletemplates_not_included.find((i) => i.id == key)
        let selected_option = obj.selected_option

        if (mt && selected_option != "" && selected_option != "none" && vm.moduleoptioncoursetypes[selected_option] !== undefined) {
          // Add the price of the selected module option
          let mo = mt.module_options.find((i) => i.id == selected_option)
          if (mo) {
            vm.price_additional += mo.price
          }

          // Add the price of the selected course types
          _.forEach(obj.selected_coursetypes, function (ct) {
            let moct = vm.moduleoptioncoursetypes[selected_option].find((i) => i.id == ct)

            if (moct) {
              vm.price_additional += moct.price
            }
          })
        }
      })

      vm.price_total = vm.price + vm.price_additional
    }
  }
}
</script>

<style scoped>
.privacy-line {
  margin-top: 22px;
}
.privacy-link {
  font-size: 14px;
}
.chk-moduleoption {
  height: 30px;
  padding-top: 3px;
  margin-top: 0;
}
.text-gray {
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>
